import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 899.000000 716.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,716.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M1633 6192 l-53 -3 0 -330 c0 -181 3 -329 6 -329 4 0 53 -7 110 -15
125 -19 286 -63 377 -104 257 -115 467 -357 561 -643 38 -116 46 -167 76 -488
45 -466 219 -835 541 -1147 220 -213 538 -380 844 -442 338 -68 680 -50 991
55 135 45 351 157 464 240 222 163 419 397 528 629 113 238 149 383 187 750
29 270 65 418 141 569 101 202 295 389 497 480 112 50 286 97 415 111 l62 7 0
327 c0 180 -2 330 -4 332 -10 10 -270 -12 -359 -30 -630 -132 -1174 -645
-1342 -1265 -29 -106 -49 -239 -65 -421 -22 -259 -64 -433 -137 -570 -33 -63
-125 -192 -170 -241 -265 -285 -680 -410 -1068 -322 -293 66 -552 252 -699
499 -99 166 -142 325 -176 654 -28 279 -59 424 -125 590 -122 309 -383 622
-685 822 -239 158 -514 262 -740 279 -36 3 -78 6 -95 7 -16 1 -54 1 -82 -1z"
          />
          <path
            d="M4441 1883 c-58 -2 -110 -8 -116 -13 -8 -6 -9 -31 -4 -77 19 -173 29
-635 21 -973 -5 -195 -7 -358 -5 -362 2 -5 53 -8 112 -8 101 0 110 2 123 22
l15 23 50 -28 c32 -17 79 -31 126 -37 190 -27 348 52 452 225 98 164 110 397
29 562 -36 74 -115 157 -177 187 -135 64 -333 52 -431 -25 -55 -43 -56 -35
-49 251 l6 260 -24 -2 c-13 -1 -71 -4 -128 -5z m448 -642 c112 -58 171 -225
137 -387 -34 -163 -106 -240 -236 -251 -73 -7 -164 18 -185 51 -12 18 -17 74
-22 273 l-6 249 24 23 c64 62 208 82 288 42z"
          />
          <path
            d="M3425 1869 c-22 -5 -54 -24 -72 -41 -88 -85 -60 -239 49 -266 81 -21
154 11 195 84 71 124 -31 256 -172 223z"
          />
          <path
            d="M3946 1865 c-156 -41 -167 -264 -15 -305 73 -20 157 20 195 92 22 43
18 119 -9 159 -37 56 -95 74 -171 54z"
          />
          <path
            d="M80 1760 c0 -17 64 -139 129 -248 164 -272 230 -406 262 -529 18 -72
19 -96 13 -305 l-7 -228 138 0 138 0 -8 233 -7 233 26 77 c38 112 71 174 233
431 144 229 174 281 187 324 l8 23 -137 -3 -137 -3 -18 -55 c-19 -61 -49 -133
-108 -260 -71 -153 -102 -228 -115 -281 -8 -29 -18 -54 -23 -56 -5 -2 -19 32
-31 75 -11 42 -61 163 -109 267 -48 105 -97 217 -109 250 l-23 60 -151 3
c-101 2 -151 -1 -151 -8z"
          />
          <path
            d="M2659 1436 c-166 -35 -259 -136 -259 -282 0 -127 79 -214 260 -288
175 -72 237 -128 214 -194 -16 -46 -84 -63 -234 -58 -74 2 -145 10 -175 20
-35 11 -51 12 -56 4 -11 -17 -32 -165 -25 -176 6 -10 113 -28 226 -37 96 -8
259 16 331 48 108 49 161 130 163 247 1 79 -35 163 -92 210 -40 33 -152 89
-270 135 -86 34 -125 72 -120 119 2 22 13 37 37 53 30 20 46 23 134 23 59 0
127 -7 165 -16 35 -9 66 -13 69 -10 7 7 32 132 33 163 0 18 -9 23 -51 32 -86
19 -276 22 -350 7z"
          />
          <path
            d="M3400 1416 c-58 -7 -104 -16 -104 -21 25 -164 38 -648 25 -887 -12
-207 -26 -269 -81 -337 l-31 -40 33 -65 c18 -36 36 -66 40 -66 4 0 33 10 64
21 66 25 137 86 166 143 53 103 51 84 53 646 1 289 5 546 10 573 l7 47 -38 -2
c-22 0 -86 -6 -144 -12z"
          />
          <path
            d="M3945 1419 c-146 -15 -133 -1 -118 -126 8 -70 12 -236 12 -473 l-1
-365 128 0 127 0 -4 130 c-5 162 -5 572 0 725 l4 115 -29 1 c-16 1 -69 -2
-119 -7z"
          />
          <path
            d="M1359 1413 l-86 -4 4 -302 c5 -408 18 -505 78 -583 53 -70 200 -112
328 -94 72 11 188 58 224 91 25 24 43 18 43 -16 0 -53 4 -55 127 -55 l115 0
-6 43 c-4 23 -9 240 -12 482 l-5 440 -44 0 c-25 -1 -82 -2 -128 -3 l-83 -2 4
-365 5 -365 -56 -26 c-35 -15 -82 -27 -124 -30 -58 -5 -75 -2 -113 18 -54 28
-77 69 -91 165 -13 84 -15 362 -5 506 l8 107 -49 -2 c-26 -1 -87 -4 -134 -5z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
